import { connect } from 'react-redux';

import ResourceAdminEditScreen from '../components/ResourceAdminEditScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    isLoading: state.resourcesAdmin.get('isLoading'),
    success: state.resourcesAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const ResourceAdminEditScreenContainer = connect(mapStateToProps)(
  ResourceAdminEditScreen
);

export default ResourceAdminEditScreenContainer;
